import React from 'react';
import ordinalNumber from 'utils/ordinalNumber';
import isNil from 'lodash/isNil';
import './CoachingPlanDescription.styl';
import {RECURRENCE_COUNT_TYPE, RECURRENCE_END_DATE_TYPE} from 'records/EventSchedule';
import {nonSkillRelated} from 'records/CoachingContentDetail';

const formatDate = date => date.format('MMM D, YYYY');

export default class CoachingPlanDescription extends React.PureComponent {
  /**
   * Return a sane value for plan duration.
   *
   * @param plan
   * @param endDate
   * @return {string}
   */
  getDuration(plan, endDate) {
    if (plan.completed && plan.reviews.filter(r => r.status === 'COMPLETED').size === 0) {
      return 'Plan ended (no meetings)';
    }

    if (endDate) {
      return formatDate(plan.created) + ' to ' + formatDate(endDate);
    }

    return 'No end date';
  }

  render() {
    const {coachingPlan, skill, contentDetail, planVelocity} = this.props;
    const {schedule} = coachingPlan;
    const endDate =
      planVelocity && planVelocity.planProgress && planVelocity.planProgress.projectedEnd;
    const totalMeetings =
      planVelocity && planVelocity.planProgress && planVelocity.planProgress.total;

    const {weeksBetween} = schedule;

    return (
      <section className="coaching-plan-description">
        <div>
          <strong>Plan Duration:</strong> <span>{this.getDuration(coachingPlan, endDate)}</span>
        </div>
        {coachingPlan.objective && (
          <div>
            <strong>Objective: </strong> {coachingPlan.objective}
          </div>
        )}
        <SkillPhrase
          skill={skill}
          contentDetail={contentDetail}
          schedule={schedule}
          totalMeetings={totalMeetings}
        />
        <div>
          <strong>Meeting Frequency: </strong>{' '}
          {weeksBetween > 0 ? 'Every ' + ordinalNumber(weeksBetween + 1) + ' week' : 'Weekly'}
        </div>
      </section>
    );
  }
}

function SkillPhrase({skill, contentDetail, schedule, totalMeetings}) {
  const skillName = skill ? skill.skill : contentDetail.custom;
  const isNonSkill = contentDetail.custom === nonSkillRelated.custom;

  const baseline = !isNil(contentDetail.skillBaseline) ? `${contentDetail.skillBaseline}%` : '';

  const {recurrenceEndType, recurrenceCount} = schedule;

  let overBlurb = undefined;

  if (recurrenceEndType === RECURRENCE_COUNT_TYPE) {
    overBlurb = ` over ${recurrenceCount} meetings`;
  } else if (recurrenceEndType === RECURRENCE_END_DATE_TYPE) {
    overBlurb = ` over ${totalMeetings} meetings`;
  }

  return (
    <div>
      <strong>Goal: </strong> Improve average
      {skillName && !isNonSkill ? ' ' + skillName : ''} score
      {!isNil(contentDetail.skillGoal) && (
        <span>
          {' '}
          from {baseline} to {contentDetail.skillGoal}%
        </span>
      )}
      {overBlurb && <span>{overBlurb}</span>}
    </div>
  );
}
